// eslint-disable-next-line import/prefer-default-export
import { isUndefined, omitBy } from 'lodash';

export function getNested(obj, path, delimiter = '.') {
    const props = path.split(delimiter);
    return props.reduce((currObj, level) => currObj && currObj[level], obj);
}

export function clearUndefinedFields(obj) {
    return omitBy(obj, isUndefined);
}
